import { HTMLAttributes } from 'react'

import SVGIcon from '@/components/base/svg-icon'

import { cn } from '@/lib/utils'
import { WPMenu } from '@/types'

export type SocialsProps = HTMLAttributes<HTMLElement> &
  Partial<{
    theme: 'light' | 'dark'
    list: WPMenu
  }>

const Socials = ({
  theme = 'dark',
  list,
  className,
  ...props
}: SocialsProps) => {
  return (
    <ul className={cn('flex space-x-[1.6rem]', className)} {...props}>
      {list?.menu.map(({ url, title, classes }) => (
        <li key={classes}>
          <a
            href={url}
            target="_blank"
            className={cn(
              'group flex h-[4.4rem] w-[4.4rem] items-center justify-center rounded-full border-[.1rem]',
              'transition-colors duration-300 ease-out-cubic',
              {
                'border-light/30': theme === 'light',
                'border-dark/15': theme === 'dark'
              },
              'hover:border-copper'
            )}
            aria-label={classes}
          >
            <span className="sr-only">{title}</span>
            <SVGIcon
              symbol={`${classes}-icon`}
              className={cn(
                'transition-colors duration-300 ease-out-cubic',
                {
                  'fill-dark/80': theme === 'dark',
                  'fill-light/80': theme === 'light'
                },
                {
                  'h-[1rem] w-[0.6rem]': classes === 'facebook',
                  'h-[1.2rem] w-[1.2rem]': classes === 'instagram'
                },
                'group-hover:fill-copper'
              )}
            />
          </a>
        </li>
      ))}
    </ul>
  )
}

export default Socials
